import { getQueryParamsAndQueryString } from '@thoughtspot/env-flags';
import { CLDR_OVERRIDE_MAP } from '@thoughtspot/number-format-util';
import _ from 'lodash';
const resourceMap = {};
export const resourceLoader = async (_resourcePath = '') => {
    const resourcePath = window.__resolveAssetUrl
        ? window.__resolveAssetUrl(_resourcePath.toLocaleLowerCase())
        : _resourcePath.toLocaleLowerCase();
    if (!resourceMap[resourcePath]) {
        resourceMap[resourcePath] = fetch(resourcePath)
            .then(res => res.json())
            .catch(() => {
            resourceMap[resourcePath] = null;
        });
    }
    const result = await resourceMap[resourcePath];
    return result;
};
const getTranslationsPath = (locale, resourceType) => {
    const translationsPath = `@thoughtspot/translations/resources/${resourceType}/`;
    const resourcePrefix = `${resourceType}-`;
    const { queryParams } = getQueryParamsAndQueryString();
    if (resourceType === 'string' &&
        queryParams?.cdnBasePath &&
        queryParams?.assets?.path &&
        queryParams?.assets?.translations?.localeSuffix) {
        return (`${queryParams.cdnBasePath}/` +
            `${queryParams.assets.path}/` +
            `${resourcePrefix}${locale}` +
            `${queryParams.assets.translations.localeSuffix}.json`).toLowerCase();
    }
    const microfrontends = window?.blink?.microfrontends;
    if (microfrontends?.isCdnEnabled && microfrontends?.cdnBasePath) {
        if (resourceType === 'string' &&
            microfrontends?.assets?.translations?.localeSuffix &&
            microfrontends?.assets?.path) {
            return (`${microfrontends?.cdnBasePath}/` +
                `${microfrontends?.assets?.path}/` +
                `${resourcePrefix}${locale}` +
                `${microfrontends?.assets?.translations?.localeSuffix}.json`).toLowerCase();
        }
    }
    if (window?.blink?.depsPath && window?.blink?.localeSuffix && locale) {
        const dependenciesPath = window.blink.depsPath;
        const localeSuffix = window.blink.localeSuffix;
        return `${dependenciesPath}/${translationsPath}${resourcePrefix}${locale}${localeSuffix}.json`.toLowerCase();
    }
    if (locale) {
        if (resourceType !== 'strings') {
            const overrideLocale = CLDR_OVERRIDE_MAP[locale] ?? locale;
            return `node_modules/${translationsPath}${resourcePrefix}${overrideLocale}.json`;
        }
        return `node_modules/${translationsPath}${resourcePrefix}${locale}.json`;
    }
    return '';
};
export const getStringsTranslationsPath = (locale) => {
    return getTranslationsPath(locale, 'strings');
};
export const getNumbersTranslationsPath = (locale) => {
    return getTranslationsPath(locale, 'number-formats');
};
export const getDateFormatsTranslationsPath = (locale) => {
    return getTranslationsPath(locale, 'date-formats');
};
export function getRegexForEmbedStringReplacement(keyToReplace) {
    const escapedKey = keyToReplace.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(?<=[^A-Za-z0-9]|^)${escapedKey}(?=$|[^A-Za-z0-9])`, 'g');
    return regex;
}
export function updateStringsForEmbed(currentStrings, overrides) {
    if (!overrides)
        return currentStrings;
    const updatedStrings = { ...currentStrings };
    Object.entries(updatedStrings).forEach(([key, value]) => {
        if (typeof value === 'object') {
            updatedStrings[key] = updateStringsForEmbed(value, overrides);
            return;
        }
        let newValue = value;
        Object.keys(overrides).forEach(keyToReplace => {
            const valueToReplaceWith = overrides[keyToReplace];
            const regex = getRegexForEmbedStringReplacement(keyToReplace);
            if (newValue.includes(keyToReplace)) {
                newValue = newValue.replace(regex, valueToReplaceWith);
            }
        });
        updatedStrings[key] = newValue;
    });
    return updatedStrings;
}
export function updateTranslationOverridesWithKeys(currentStrings, stringIDOverrides) {
    if (!stringIDOverrides)
        return currentStrings;
    const updatedStrings = { ...currentStrings };
    Object.entries(stringIDOverrides).forEach(([key, value]) => {
        if (_.has(updatedStrings, key) && _.escape(value)) {
            _.set(updatedStrings, key, _.escape(value));
        }
    });
    return updatedStrings;
}
//# sourceMappingURL=util.js.map